import { useFlags } from "launchdarkly-react-client-sdk";
import moment from "moment";
import React, { useState } from "react";

import Christmas2 from "../../assets/imgs/christmas-otto.svg";
import Christmas1 from "../../assets/imgs/christmas-scribbles.svg";
import Halloween2 from "../../assets/imgs/halloween-otto.svg";
import Halloween1 from "../../assets/imgs/halloween-scribbles.svg";
import Valentines1 from "../../assets/imgs/otto-love.svg";
import Valentines2 from "../../assets/imgs/scribbles-love.svg";
import RandomImage1 from "../../assets/imgs/user-placeholder-1.svg";
import RandomImage2 from "../../assets/imgs/user-placeholder-2.svg";
import RandomImage3 from "../../assets/imgs/user-placeholder-3.svg";
import RandomImage4 from "../../assets/imgs/user-placeholder-4.svg";
import Twemoji from "../../Twemoji";

function useRandomItem(itemList) {
  const [index] = useState(() =>
    Math.floor(Math.random() * itemList.length),
  );
  return itemList[index];
}

export function RandomSuccessEmoji() {
  const emojiList = [
    <Twemoji key={0} emoji="😎" />,
    <Twemoji key={1} emoji="🚀" />,
    <Twemoji key={2} emoji="🎉" />,
    <Twemoji key={3} emoji="💪" />,
    <Twemoji key={4} emoji="😍" />,
    <Twemoji key={5} emoji="🤠" />,
    <Twemoji key={6} emoji="🙌" />,
    <Twemoji key={7} emoji="🤩" />,
    <Twemoji key={8} emoji="🥳" />,
    <Twemoji key={9} emoji="⭐️" />,
  ];

  return useRandomItem(emojiList);
}

export function RandomUserImage() {
  const { hideHolidayTheming } = useFlags();
  let imageList = [];
  let currentYear = new Date().getFullYear();

  if (
    !hideHolidayTheming &&
    moment().isSame(`${currentYear}-10-31`, "day")
  ) {
    imageList = [
      <img key={0} src={Halloween1} />,
      <img key={1} src={Halloween2} />,
    ];
  } else if (
    !hideHolidayTheming &&
    (moment().isSame(`${currentYear}-12-24`, "day") ||
      moment().isSame(`${currentYear}-12-25`, "day"))
  ) {
    imageList = [
      <img key={0} src={Christmas1} />,
      <img key={1} src={Christmas2} />,
    ];
  } else if (
    !hideHolidayTheming &&
    moment().isSame(`${currentYear}-02-14`, "day")
  ) {
    imageList = [
      <img key={0} src={Valentines1} />,
      <img key={0} src={Valentines2} />,
    ];
  } else {
    imageList = [
      <img key={0} src={RandomImage1} />,
      <img key={1} src={RandomImage2} />,
      <img key={2} src={RandomImage3} />,
      <img key={3} src={RandomImage4} />,
    ];
  }

  return useRandomItem(imageList);
}
